import { memo, useMemo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import { BANNER_TITLE, DESCRIPTION } from './delete-column-modal.constant';
import Banner from '@/components/ui/banner';
import { TriangleAlert } from 'lucide-react';
import { useDeleteColumnModal } from './use-delete-column-modal';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';

export type TDeleteColumnModalType = 'DeleteColumnModal';
export interface IDeleteColumnModalProps {
  spaceId: string;
  spaceColumnId: string;
}
const DeleteColumnModal = memo(({ spaceId, spaceColumnId }: IDeleteColumnModalProps) => {
  const {
    // Form
    form,

    // Modal
    isOpenDeleteTicketingColumnModal,

    // Mutation
    mutationDeleteColumn,

    // Handlers
    handleCloseModal,
    handleSubmitForm,
  } = useDeleteColumnModal({
    spaceId,
    spaceColumnId,
  });

  const isDisabledForm = useMemo(() => {
    return mutationDeleteColumn.isPending;
  }, [mutationDeleteColumn.isPending]);

  const isLoadingForm = useMemo(() => {
    return mutationDeleteColumn.isPending;
  }, [mutationDeleteColumn.isPending]);

  return (
    <Modal
      isOpen={isOpenDeleteTicketingColumnModal}
      lockBodyScroll
      onClose={handleCloseModal}
      className="p-[32px] md:w-[420px] w-[345px]"
    >
      <ModalHeader>
        <ModalTitle>Delete Column</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="delete-ticketing-space-column-form"
          className="grid gap-[4px]"
        >
          <Banner className="my-[8px]" icon={TriangleAlert} title={BANNER_TITLE} variant="warning" />
          <div className="text-[14px] font-normal text-[#9D9D9C]">{DESCRIPTION}</div>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCloseModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="delete-ticketing-space-column-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner className="w-[18px] h-[18px]" /> : null} Delete
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
DeleteColumnModal.displayName = 'DeleteColumnModal';

export default DeleteColumnModal;
